// reducers/attendanceReducer.js
export const attendanceReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_ATTENDANCE_REQUEST":
    case "MARK_ATTENDANCE_REQUEST":
      return { ...state, loading: true };
    case "GET_ATTENDANCE_SUCCESS":
      return { loading: false, attendance: action.payload };
    case "GET_ATTENDANCE_SUMMARY_SUCCESS":
      return { loading: false, summary: action.payload };
    case "MARK_ATTENDANCE_SUCCESS":
      return { ...state, loading: false, success: true };
    case "GET_ATTENDANCE_FAIL":
    case "MARK_ATTENDANCE_FAIL":
      return { loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };
    default:
      return state;
  }
};
